import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

import './redirect-block.less';

const resolveUrl = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (Array.isArray(value) && value.length > 0) {
    return flattenToAppURL(value[0]?.['@id'] || '');
  }
  return '';
};

const View = ({ data, mode }) => {
  const history = useHistory();
  const [countdown, setCountdown] = useState(3);
  const url = resolveUrl(data?.url);

  const isLoggedIn = useSelector((state) => !!state.userSession?.token);
  const isEditorCanvas = mode === 'edit';
  const shouldRedirect = !isLoggedIn && !isEditorCanvas;

  useEffect(() => {
    if (!shouldRedirect || !url) return;

    if (countdown === 0) {
      const isExternal = /^https?:\/\//i.test(url);
      if (isExternal) {
        window.location.href = url;
      } else {
        history.push(url);
      }
      return;
    }

    const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown, shouldRedirect, url, history]);

  if (!url) {
    return (
      <div className="redirect-block redirect-block--unconfigured">
        Redirect block: no URL configured.
      </div>
    );
  }

  if (!shouldRedirect) {
    return (
      <div className="redirect-block redirect-block--preview">
        <span className="redirect-block__arrow">→</span>
        Visitors will be redirected to{' '}
        <strong className="redirect-block__url">{url}</strong>
      </div>
    );
  }

  return (
    <div className="redirect-block redirect-block--redirecting" role="status" aria-live="polite">
      <span className="redirect-block__spinner" aria-hidden="true" />
      Redirecting{countdown > 0 ? ` in ${countdown}…` : '…'}
    </div>
  );
};

export default View;
